import { FabHoldReason } from './fab-hold-reason'
import { FabJob } from './fab-job'
import { FabPiece } from './fab-piece'
import { FabProcessStep } from './fab-process-step'

export class FabBoard {
    jobs: FabJob[] = []
    processSteps: FabProcessStep[] = []
    pieces: FabPiece[] = []
    holdReasons: FabHoldReason[] = []
}

export class FabStampStepRequest {
    fabPieceId!: string
    fabProcessStepId!: string
    actualDate?: Date | string | null
    clear!: boolean
    note?: string | null
}

export class FabStepApplicabilityItem {
    fabProcessStepId!: string
    isNotApplicable!: boolean
}

export class FabSetStepApplicabilityRequest {
    fabPieceId!: string
    steps: FabStepApplicabilityItem[] = []
}
